import { createRouter, createWebHistory } from 'vue-router'
import { ReviseMeta } from '@/util/meta'
import { client } from '@/util/base'
import { getServerTime, init } from '@/api/construct'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'home',
      path: '/',
      component: () => import('./views/home/index.vue'),
      children: [
        // 预约页
        ...['/', '/m'].map((path) => {
          return {
            path,
            component: () => import('./views/reserve/index.vue'),
            meta: {
              title: '《盗墓笔记》游戏官网-南派三叔正版授权-来盗墓笔记做爽文主角',
              keywords:
                '盗墓笔记游戏下载,盗墓笔记,盗墓笔记手游,南派三叔,盗墓笔记正版,吴邪,张起灵,王胖子,盗墓笔记官网,秦岭神树,七星鲁王宫,云顶天宫,蛇沼鬼城,阴山古楼,禁婆,青铜门',
              description:
                '《盗墓笔记》是由南派三叔正版授权，携手铁三角吴邪、张起灵、王胖子共同打造的沉浸式古墓探险手游。十年之约未了，新的谜题再起，这一次你将化身摸金校尉，跟随铁三角深入千年古墓，揭开青铜门后的终极秘密！',
            },
          }
        }),
        // 抽奖页
        {
          path: '/lottery',
          component: () => import('./views/lottery/index.vue'),
        },
        // 下载页
        {
          path: '/bd/281505/',
          component: () => import('./views/bd/index.vue'),
        },
      ],
    },
  ],
})

let isInit = false
router.beforeEach(async (to, from, next) => {
  if (!isInit) {
    await getServerTime()
    // 初始化接口
    await init()
    isInit = true
  }
  // 路由发生变化改变description和keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)
  const isMobile = client() === '2'

  if (isMobile) {
    if (to.path == '/') {
      next({ path: '/m', query: to.query })
    } else {
      next()
    }
  } else {
    if (to.path == '/m') {
      next({ path: '/', query: to.query })
    } else {
      next()
    }
  }
})

export default router
